import BookingForm from "@/components/BookingForm";

import SharedNavbar from "@/components/SharedNavbar";
import { CheckCircle2, Trash2, ArrowRight, Phone, Truck, ShieldCheck, Clock3 } from "lucide-react";

const LOGO_URL =
  "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-23/prod_agent_3a0812e8-cabc-4e60-9023-9eb878dbad11/ds_logo_transparent_1343324419e041449c280c0bfa45d1f3.png";

const detailPricing = [
  { position: "Küche ohne Elektrogeräte",          price: "CHF 150.–",  unit: "/ lfm" },
  { position: "Badezimmer-Einrichtung",             price: "CHF 120.–",  unit: "/ lfm" },
  { position: "Wohnzimmermöbel (Schrankwände)",     price: "CHF 130.–",  unit: "/ lfm" },
  { position: "Schlafzimmermöbel / Regale",         price: "CHF 110.–",  unit: "/ lfm" },
  { position: "Küchenelektrogeräte",                price: "CHF 30.–",   unit: "/ Stk." },
  { position: "Zuschlag Abtransport Elektrogerät",  price: "CHF 15.–",   unit: "/ Gerät" },
  { position: "Waschbecken (Sondermüll)",           price: "CHF 50.–",   unit: "/ Stk." },
  { position: "Lampen (Sondermüll)",                price: "CHF 28.–",   unit: "/ Stk." },
];

const einzelPricing = [
  { kategorie: "Polster",       position: "Sofa (2- oder 3-sitzig)",                    price: "CHF 55.–",   unit: "/ Sitz" },
  { kategorie: "Tische",        position: "Couch-, Beistell- oder Küchentisch",          price: "CHF 65.–",   unit: "/ Stk." },
  { kategorie: "Tische",        position: "Eckbankgruppe",                               price: "CHF 180.–",  unit: "/ Stk." },
  { kategorie: "Einzelmöbel",   position: "Anrichte, Schreibtisch oder Vitrine",         price: "CHF 80.–",   unit: "/ Stk." },
  { kategorie: "Bett",          position: "Französisches Bett / Boxspringbett",          price: "CHF 180.–",  unit: "/ Stk." },
  { kategorie: "Bett",          position: "Bett, Liege oder Einzelcouch",                price: "CHF 110.–",  unit: "/ Stk." },
  { kategorie: "Bett",          position: "Lattenrost / Matratze",                       price: "CHF 60.–",   unit: "/ Stk." },
  { kategorie: "Bett",          position: "Nachttisch",                                  price: "CHF 39.–",   unit: "/ Stk." },
  { kategorie: "Deko",          position: "Karniese / Gardinenstange",                   price: "CHF 35.–",   unit: "/ Stk." },
  { kategorie: "Stuhl",         position: "Stuhl",                                       price: "CHF 20.–",   unit: "/ Stk." },
];

const steps = [
  { num: "01", title: "Anfrage stellen", text: "Rufen Sie uns an oder schreiben Sie uns — wir erstellen Ihnen ein unverbindliches Angebot." },
  { num: "02", title: "Termin vereinbaren", text: "Wir vereinbaren einen Termin, der zu Ihnen passt — auch kurzfristig möglich." },
  { num: "03", title: "Demontage & Abtransport", text: "Unser Team demontiert alles fachgerecht vor Ort und lädt es sorgfältig auf den LKW." },
  { num: "04", title: "Fachgerechte Entsorgung", text: "Alle Materialien werden umweltgerecht und vorschriftsgemäss entsorgt. Fertig!" },
];

export default function Entsorgung() {
  return (
    <div className="min-h-screen bg-background">
      <SharedNavbar />

      {/* Hero */}
      <section className="bg-gradient-to-br from-slate-900 via-slate-800 to-red-900 py-16 text-white">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <div className="max-w-3xl">
            <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-white/80">
              <Trash2 className="h-3.5 w-3.5 text-red-400" />
              Entsorgung & Rückbau
            </div>
            <h1 className="text-4xl font-bold leading-tight sm:text-5xl">
              Wir übernehmen alles —<br />
              <span className="text-red-400">von der Demontage bis zur Entsorgung</span>
            </h1>
            <p className="mt-5 text-lg text-white/75 leading-relaxed">
              Sie müssen sich um nichts kümmern. Unser erfahrenes Team demontiert Ihre alten Möbel, Küchen und Haushaltsgeräte fachgerecht vor Ort und entsorgt alles umweltgerecht und gesetzeskonform — sauber, schnell und zum Fixpreis.
            </p>
            <div className="mt-6 flex flex-wrap gap-4 text-sm">
              <button
                onClick={() => { const el = document.getElementById("termin-anfragen"); if(el){ el.scrollIntoView({behavior:"smooth",block:"start"}); setTimeout(()=>{ const f = document.getElementById("booking-name"); if(f) f.focus(); }, 600); }}}
                className="inline-flex items-center gap-2 rounded-full bg-white text-slate-900 px-6 py-3 text-sm font-bold shadow-lg hover:-translate-y-px transition-all"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M8 2v4M16 2v4M3 10h18M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z"/></svg>
                Jetzt anfragen
              </button>
              {[
                "Demontage inklusive",
                "Umweltgerechte Entsorgung",
                "Fixpreise — keine Überraschungen",
                "Direkt nach Lieferung möglich",
              ].map((f) => (
                <div key={f} className="flex items-center gap-1.5 text-white/80">
                  <CheckCircle2 className="h-4 w-4 text-green-400" />
                  {f}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Was wir entsorgen */}
      <section className="py-16 border-b border-border/40">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <div className="text-center mb-12">
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-primary">Unser Angebot</p>
            <h2 className="mt-3 text-3xl font-bold text-foreground sm:text-4xl">Was wir entsorgen</h2>
            <p className="mt-3 text-muted-foreground max-w-2xl mx-auto">
              Von der einzelnen Couch bis zur kompletten Kücheneinrichtung — wir haben die Kapazitäten und das Know-how für jeden Auftrag.
            </p>
          </div>
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {[
              { icon: "🛋️", label: "Sofas & Polstermöbel" },
              { icon: "🍳", label: "Küchen & Einbaugeräte" },
              { icon: "🛏️", label: "Schlafzimmer-Sets" },
              { icon: "📦", label: "Schränke & Regale" },
              { icon: "🖥️", label: "Elektrogeräte" },
              { icon: "🪑", label: "Stühle & Tische" },
              { icon: "🚿", label: "Badmöbel" },
              { icon: "🏠", label: "Komplette Wohnungsauflösung" },
            ].map(({ icon, label }) => (
              <div
                key={label}
                className="flex items-center gap-3 rounded-2xl border border-border/60 bg-card px-5 py-4"
              >
                <span className="text-2xl">{icon}</span>
                <span className="text-sm font-semibold text-foreground">{label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing */}
      <section className="py-20">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <div className="text-center mb-12">
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-primary">Transparente Preise</p>
            <h2 className="mt-3 text-3xl font-bold text-foreground sm:text-4xl">Preisliste Rückbau & Entsorgung</h2>
            <p className="mt-3 text-muted-foreground max-w-2xl mx-auto">
              Alle Preise verstehen sich inklusive Demontage, Abtransport und fachgerechter Entsorgung. Keine versteckten Kosten — wir übernehmen alles.
            </p>
          </div>

          {/* Detaillierte Preistabelle */}
          <div className="rounded-3xl border border-border/60 bg-card overflow-hidden" style={{ boxShadow: "0 16px 48px -24px rgba(37,10,8,0.18)" }}>
            {/* Tabellenkopf */}
            <div className="grid grid-cols-3 bg-primary px-6 py-4">
              <span className="text-sm font-bold text-white uppercase tracking-wide">Position</span>
              <span className="text-sm font-bold text-white uppercase tracking-wide text-center">Preis</span>
              <span className="text-sm font-bold text-white uppercase tracking-wide text-right">Einheit</span>
            </div>
            {/* Zeilen */}
            {detailPricing.map((row, i) => (
              <div
                key={row.position}
                className={`grid grid-cols-3 items-center px-6 py-4 border-b border-border/40 last:border-0 transition-colors hover:bg-primary/5 ${i % 2 === 0 ? "bg-background" : "bg-muted/30"}`}
              >
                <span className="text-sm font-medium text-foreground">{row.position}</span>
                <span className="text-center font-mono text-lg font-bold text-primary">{row.price}</span>
                <span className="text-right text-sm text-muted-foreground">{row.unit}</span>
              </div>
            ))}
          </div>

          {/* Zweite Tabelle — Einzelmöbel */}
          <div className="mt-12">
            <h3 className="text-xl font-bold text-foreground mb-2">Einzelmöbel & Zusatzpositionen</h3>
            <p className="text-sm text-muted-foreground mb-6">Entsorgungspreise für einzelne Möbelstücke — Demontage, Abtransport und Entsorgung immer inklusive.</p>
            <div className="rounded-3xl border border-border/60 bg-card overflow-hidden" style={{ boxShadow: "0 16px 48px -24px rgba(37,10,8,0.18)" }}>
              {/* Kopf */}
              <div className="grid grid-cols-4 bg-slate-800 px-6 py-4">
                <span className="text-xs font-bold text-white/70 uppercase tracking-wide">Kategorie</span>
                <span className="col-span-2 text-sm font-bold text-white uppercase tracking-wide">Position</span>
                <span className="text-sm font-bold text-white uppercase tracking-wide text-right">Preis</span>
              </div>
              {einzelPricing.map((row, i) => (
                <div
                  key={`${row.kategorie}-${row.position}`}
                  className={`grid grid-cols-4 items-center px-6 py-4 border-b border-border/40 last:border-0 hover:bg-primary/5 transition-colors ${i % 2 === 0 ? "bg-background" : "bg-muted/30"}`}
                >
                  <span className="text-xs font-semibold text-primary uppercase tracking-wide">{row.kategorie}</span>
                  <span className="col-span-2 text-sm font-medium text-foreground">{row.position}</span>
                  <span className="text-right font-mono text-base font-bold text-primary">{row.price} <span className="text-xs font-normal text-muted-foreground">{row.unit}</span></span>
                </div>
              ))}
            </div>
          </div>

          {/* Erklärungstext */}
          <div className="mt-8 rounded-2xl bg-amber-50 border border-amber-200 px-6 py-4">
            <p className="text-sm text-amber-800 leading-relaxed">
              <span className="font-bold">Hinweis:</span> «lfm» = Laufmeter. Sondermüll (Waschbecken, Lampen) wird separat nach gesetzlichen Vorschriften entsorgt und einzeln abgerechnet. Alle übrigen Positionen beinhalten Demontage, Abtransport und umweltgerechte Entsorgung.
            </p>
          </div>

          {/* Alles inklusive banner */}
          <div className="mt-6 rounded-3xl bg-primary/5 border border-primary/20 p-6 sm:p-8">
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <ShieldCheck className="h-10 w-10 shrink-0 text-primary" />
              <div>
                <h3 className="text-lg font-bold text-foreground">Im Preis immer inklusive:</h3>
                <div className="mt-2 flex flex-wrap gap-x-6 gap-y-1 text-sm text-muted-foreground">
                  {[
                    "Demontage vor Ort",
                    "Fachgerechter Abtransport",
                    "Umweltgerechte Entsorgung",
                    "Sauber hinterlassen",
                    "Kein Aufpreis für Treppen",
                    "Alles aus einer Hand",
                  ].map((i) => (
                    <span key={i} className="flex items-center gap-1.5">
                      <CheckCircle2 className="h-3.5 w-3.5 text-green-500" /> {i}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Warum DS Logistik */}
      <section className="py-16 bg-muted/30 border-y border-border/40">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <div className="grid gap-10 lg:grid-cols-2 items-center">
            <div>
              <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-primary">Warum DS Logistik</p>
              <h2 className="mt-3 text-3xl font-bold text-foreground sm:text-4xl">
                Professionell, pünktlich & umweltbewusst
              </h2>
              <p className="mt-4 text-muted-foreground leading-relaxed">
                Seit 2005 sind wir der verlässliche Partner für Möbellogistik und Entsorgung in der Schweiz. Mit über 150 Fahrzeugen und 350 ausgebildeten Mitarbeitern bewältigen wir Aufträge jeder Grösse — zuverlässig, termingerecht und zum Festpreis.
              </p>
              <p className="mt-4 text-muted-foreground leading-relaxed">
                Wir übernehmen nicht nur den Transport — wir demontieren Ihre alten Möbel fachgerecht vor Ort, tragen alles ab und hinterlassen Ihren Raum sauber und leer. So haben Sie sofort Platz für Neues.
              </p>
              <div className="mt-6 space-y-3">
                {[
                  { icon: ShieldCheck, text: "Lizenziert & versichert für alle Entsorgungsarbeiten in der Schweiz" },
                  { icon: Truck, text: "Eigener Fuhrpark mit 150 Fahrzeugen — keine Drittanbieter" },
                  { icon: Clock3, text: "Lieferung & Entsorgung am selben Tag möglich" },
                ].map(({ icon: Icon, text }) => (
                  <div key={text} className="flex items-start gap-3">
                    <div className="mt-0.5 rounded-xl bg-primary/10 p-2 text-primary">
                      <Icon className="h-4 w-4" />
                    </div>
                    <p className="text-sm text-muted-foreground leading-6">{text}</p>
                  </div>
                ))}
              </div>
            </div>
            {/* Process steps */}
            <div className="space-y-4">
              <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-primary mb-5">So funktioniert es</p>
              {steps.map((s) => (
                <div key={s.num} className="flex gap-4 rounded-2xl border border-border/60 bg-card p-5">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/10 font-mono text-sm font-bold text-primary">
                    {s.num}
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-foreground">{s.title}</p>
                    <p className="mt-1 text-xs leading-5 text-muted-foreground">{s.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      
      {/* Termin & Anfrage */}
      <section className="py-16 bg-muted/30 border-y border-border/40">
        <div className="mx-auto max-w-3xl px-5 lg:px-8">
          <div className="text-center mb-10">
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-primary">Jetzt buchen</p>
            <h2 className="mt-3 text-3xl font-bold text-foreground">Termin anfragen</h2>
            <p className="mt-3 text-muted-foreground">Wählen Sie Service, Datum und Uhrzeit — wir melden uns innerhalb von 24 Stunden.</p>
          </div>
          <BookingForm defaultService="Entsorgung & Rückbau" />
        </div>
      </section>

      {/* CTA / Contact */}
      <section className="py-20">
        <div className="mx-auto max-w-2xl px-5 lg:px-8 text-center">
          <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-primary">Jetzt anfragen</p>
          <h2 className="mt-3 text-3xl font-bold text-foreground">Kostenlose Offerte anfordern</h2>
          <p className="mt-3 text-muted-foreground">
            Kontaktieren Sie uns für ein unverbindliches Angebot. Wir melden uns innerhalb von 24 Stunden.
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-4">
            <a
              href="tel:+41326712010"
              className="inline-flex items-center gap-2 rounded-full bg-primary px-6 py-3 text-sm font-bold text-white shadow-[0_8px_24px_-10px_rgba(200,25,11,0.6)] hover:-translate-y-px transition-all"
            >
              <Phone className="h-4 w-4" /> 032 671 20 10
            </a>
            <a
              href="https://wa.me/41798883262"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-full bg-[#25D366] px-6 py-3 text-sm font-bold text-white hover:scale-105 transition-transform"
            >
              <svg viewBox="0 0 24 24" className="h-4 w-4 fill-white">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
              </svg>
              WhatsApp
            </a>
            <a
              href={`mailto:andre.stalder@ds-logistik.ch?subject=${encodeURIComponent("Entsorgungsanfrage")}&body=${encodeURIComponent("Guten Tag,\n\nIch möchte eine Offerte für Entsorgung/Rückbau anfragen.\n\nArt des Auftrags:\nAdresse:\nWunschdatum:\n\nFreundliche Grüsse")}`}
              className="inline-flex items-center gap-2 rounded-full border border-border/60 px-6 py-3 text-sm font-semibold hover:bg-muted transition-colors"
            >
              <ArrowRight className="h-4 w-4 text-primary" /> Per E-Mail anfragen
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-border/40 bg-background py-6 text-center">
        <p className="text-xs text-muted-foreground">
          © {new Date().getFullYear()} DS Logistik · Bielstrasse 20, 4500 Solothurn ·{" "}
          <a href="/#/impressum" className="hover:text-primary">Impressum</a>
        </p>
      </footer>

      {/* WhatsApp floating button */}
      <a
        href="https://wa.me/41798883262"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-3 text-white shadow-lg hover:scale-105 transition-transform"
      >
        <svg viewBox="0 0 24 24" className="h-6 w-6 fill-white">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
        </svg>
        <span className="text-sm font-bold">WhatsApp</span>
      </a>
    </div>
  );
}
